import { createFileRoute } from "@tanstack/react-router";
import heroAsset from "@/assets/junk-removal-hero.webp.asset.json";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/junk-removal")({
  head: () => ({
    meta: [
      { title: services["junk-removal"].metaTitle },
      { name: "description", content: services["junk-removal"].metaDescription },
      { property: "og:title", content: services["junk-removal"].metaTitle },
      { property: "og:description", content: services["junk-removal"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/junk-removal" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/junk-removal" }, { rel: "preload", as: "image", href: heroAsset.url, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Junk Removal', url: 'https://anchorsrq.com/junk-removal' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "junk-removal", name: 'Junk Removal', serviceType: 'Junk Removal', description: "Full-service junk hauling across the Sarasota coast — single items to whole-home loads, sorted for donation, recycling, and responsible disposal. A supporting service of Anchor Services' Home Watch and property care offerings." })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["junk-removal"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["junk-removal"]} heroImg={heroAsset.url} />,
});
